import React, {useEffect} from "react";
import Highcharts from "highcharts";

export default function ({data, id}) {
    useEffect(() => {
        if (data.length > 0) {
            const options = {
                chart: {
                    type: 'spline',
                    zooming: {
                        type: 'x'
                    }
                },
                title: {
                    text: undefined
                },
                xAxis: {
                    type: 'datetime'
                },
                yAxis: {
                    title: {
                        text: undefined
                    },
                    labels: {
                        enabled: false
                    }
                },
                plotOptions: {
                    series: {
                        marker: {
                            symbol: 'circle',
                            fillColor: 'var(--highcharts-background-color, #ffffff)',
                            enabled: true,
                            radius: 2.5,
                            lineWidth: 1,
                            lineColor: null
                        }
                    }
                },
                tooltip: {
                    format: '{series.name}'
                },
                credits: {
                    enabled: false
                },
                series: data
            }
            Highcharts.chart('skill-regression-graph-' + id, options);
        }
    }, [data]);

    function renderEmpty() {
        if (data.length <= 0) {
            return 'No data';
        }

        return null;
    }

    return (
        <div>
            {renderEmpty()}
            <div id={"skill-regression-graph-" + id}/>
        </div>
    );
}
